import apiClient from "./axios";

const BASE_URL = "/auction-grades";

export const getAuctionGrades = async (params = {}) => {
  const response = await apiClient.get(BASE_URL, { params });
  return response.data;
};

export const getAuctionGrade = async (id) => {
  const response = await apiClient.get(`${BASE_URL}/${id}`);
  return response.data;
};

export const createAuctionGrade = async (data) => {
  const response = await apiClient.post(BASE_URL, data);
  return response.data;
};

export const editAuctionGrade = async ({ id, ...data }) => {
  const response = await apiClient.put(`${BASE_URL}/${id}`, data);
  return response.data;
};

export const deleteAuctionGrade = async (id) => {
  const response = await apiClient.delete(`${BASE_URL}/${id}`);
  return response.data;
};
